import { Pipe, PipeTransform } from '@angular/core';
import { Material } from '../classes/material.class';
import { getColorSourceRawMaterial } from './material-property.pipe';

@Pipe({
    name: 'materialDetails',
    standalone: false,
})
export class MaterialDetailsPipe implements PipeTransform {
    transform(material: Material, optional: boolean = false): string {
        if (!material?.raw_materials?.length) {
            return '';
        }

        const parts: string[] = [];

        const mainRawMaterial = material.raw_materials.find(rm => rm.material_type?.main);
        const targetRawMaterial = mainRawMaterial || material.raw_materials[0];

        if (optional) {
            if (targetRawMaterial?.supplier?.name) {
                parts.push(targetRawMaterial.supplier.name);
            }
        }

        const colorRawMaterial = getColorSourceRawMaterial(material);

        if (colorRawMaterial?.color) {
            const colorPart = colorRawMaterial.color.ral
                ? `${colorRawMaterial.color.name} (${colorRawMaterial.color.ral})`
                : colorRawMaterial.color.name;
            parts.push(colorPart);
        }

        const optionals: string[] = [];

        if (material.raw_materials.length > 1 && optional) {
            const otherRawMaterials = material.raw_materials.filter(
                rm => rm !== targetRawMaterial && !rm.material_type?.hidden
            );

            for (const raw of otherRawMaterials) {
                let rawPart = raw.name;

                if (
                    raw.material_type?.name &&
                    raw.material_type?.name.toLowerCase().trim() !== raw.name.toLowerCase().trim()
                ) {
                    rawPart += ` ${raw.material_type.name} `;
                }

                optionals.push(rawPart.trim());
            }
        }

        return optional ? optionals.join(', ') : parts.join(' - ');
    }
}
